import React,{ useEffect, useRef,useState } from "react";
import LoginButton from "./LoginButton"
import { Navigate } from "react-router-dom";
import { useIsAuthenticated } from "@azure/msal-react";
import imgLogoCentenario from "../assets/images/login/ISOTIPO.png"

const Login = () => {

const isAuthenticated = useIsAuthenticated();

useEffect(() => {
if (isAuthenticated) {
    // Redirigir al dashboard si ya está autenticado
    window.location.href = "/mainreport";
}
}, [isAuthenticated]);

  return isAuthenticated ? <Navigate to="/mainreport" replace /> :
    <div className="container-fluid d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="row w-75 h-75 shadow-lg p-3 mb-5 bg-white rounded" >
        <div className="col-12 col-md-6 text-center" style={{padding:"0px"}}>
        <div
            
            style={{ borderRight: "1px solid rgba(0, 0, 0, 0.1)", height:"100%" }}
          >
            <div className="d-flex justify-content-center align-items-center">
                
                <img 
                  src={imgLogoCentenario} 
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    marginTop: "20px"
                  }}
                  className="img-fluid"
                />
            </div>
            
          </div>
        </div>

        {/* Caja de login -> p-4 rounded */}
        <div className="col-12 col-md-6" style={{padding:"0px"}}>
          <div
            style={{ 
              height: "100%", 
              paddingTop: window.innerWidth < 768 ? "40px" : "calc(200px + 2vmin)"
            }}
          >
            <h5 className="text-center mb-3">PORTAL ANALYTICS</h5>
            <center><LoginButton /></center> 
          </div>
        </div>
      </div>
    </div>
  
};

export default Login;
